import { SweetAlertService } from './../../../../core/services/utils/sweet-alert.service';
import { EmitService } from './../../../../core/services/utils/emit.service';
import { ModalService } from './../../../../core/services/utils/modal.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-error',
  templateUrl: './modal-error.component.html',
  styleUrls: ['./modal-error.component.css']
})
export class ModalErrorComponent implements OnInit {

  constructor(
    private modalService: ModalService,
    private emit: EmitService,
    private sweetAlertService: SweetAlertService
  ) { }

  ngOnInit(): void {
    setTimeout(()=>{
      this.closeModal();
      this.sweetAlertService.swalLoading();
      this.emit.enviarData('sesion');
     },3000);
  }

  closeModal(): void {
    this.modalService.closeModal();
  }

}
